import React from "react";
import { useNavigate } from "react-router-dom";
import CuerpoTorneos from "./CuerpoTorneos.js";
import * as Funciones from "../funciones/FuncionesTorneos.js";
import styles from "./BaseTorneos.module.css";

const BaseTorneos = (props) => {
  const datosElegidos = props.datosElegidos;
  const navigate = useNavigate();

  const onDatoElegido = (filtro, valor) => {
    navigate(Funciones.NavigatePath(filtro, valor, datosElegidos), { state: { datosElegidos }});
  };

  let cabecera = Funciones.CabeceraTorneo(datosElegidos, onDatoElegido);

  return (
    <div className={`${styles.base}`}>
      {datosElegidos && (
        <React.Fragment>
          {cabecera}
          <CuerpoTorneos
            datosElegidos={datosElegidos}
            onDatoElegido={onDatoElegido}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default BaseTorneos;
